import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { pageStyles } from "./pageStyles";
import NavBar from "./NavBar";

export default function VerifyEmailPage() {
  const { verifyEmail } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    if (!token) {
      setError("This verification link is missing its token. Request a new link from the sign-up page.");
      return;
    }
    if (password !== confirmPassword) {
      setError("The passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
      const result = await verifyEmail(token, password);
      setSuccess(result.message);
      setPassword("");
      setConfirmPassword("");
    } catch (requestError) {
      setError(requestError.message || "That verification link is invalid or expired.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={pageStyles.page}>
      <NavBar />
      <div style={pageStyles.authWrap}>
        <form style={pageStyles.card} onSubmit={handleSubmit}>
          <h1 style={pageStyles.title}>Verify your email</h1>
          <p style={pageStyles.subtitle}>Choose a password to activate your account.</p>
          <label style={pageStyles.label} htmlFor="verify-password">Password</label>
          <input
            id="verify-password"
            type="password"
            required
            minLength={8}
            maxLength={128}
            autoComplete="new-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            style={pageStyles.input}
          />
          <label style={pageStyles.label} htmlFor="verify-confirm-password">Confirm password</label>
          <input
            id="verify-confirm-password"
            type="password"
            required
            minLength={8}
            maxLength={128}
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            style={pageStyles.input}
          />
          {error ? <div role="alert" style={pageStyles.errorBanner}>{error}</div> : null}
          {success ? <div role="status" style={pageStyles.successBanner}>{success}</div> : null}
          <button type="submit" disabled={submitting || Boolean(success)} style={{ ...pageStyles.button, ...(submitting ? pageStyles.buttonDisabled : {}) }}>
            {submitting ? "Verifying…" : "Verify email and set password"}
          </button>
          {success ? <div style={pageStyles.linkRow}><Link to="/login" style={pageStyles.link}>Continue to sign in</Link></div> : null}
        </form>
      </div>
    </div>
  );
}
